import React from "react";
import { Country } from "../types/Country";

export function CountryInput({
  value,
  countries,
  onChange,
}: {
  value: string;
  countries: Country[];
  onChange: (value: string) => void;
}) {
  return (
    <div>
      <label
        htmlFor="country"
        className="block text-sm font-medium leading-6 text-gray-900 sr-only"
      >
        Country
      </label>
      <select
        id="country"
        name="country"
        className="block sm:w-60 max-w-full rounded-md border-0 py-1.5 pl-3 pr-10 text-gray-900 text-ellipsis whitespace-nowrap ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-brand-primary sm:text-sm sm:leading-6"
        onChange={(event) => onChange(event.target.value)}
        value={value}
      >
        <option value="">All countries</option>
        {countries.map((country) => (
          <option key={country.value} value={country.value}>
            {country.label}
          </option>
        ))}
      </select>
    </div>
  );
}
